import { PayloadAction } from "@reduxjs/toolkit";
import { ProfileState } from "types/Profile";
import { RequestStatus } from "types";
import { FilterRole } from "types/FilterRole";

const setTaxonomyOptionsByRole = (
  state: ProfileState,
  action: PayloadAction<string[]>
) => {
  state.taxonomyOptionsByRole = action.payload;
};

const setTaxonomyOptionsByRoleRequestStatus = (
  state: ProfileState,
  action: PayloadAction<RequestStatus>
) => {
  state.taxonomyOptionsByRoleRequestStatus = action.payload;
};

const setProfileUpdateStatus = (
  state: ProfileState,
  action: PayloadAction<RequestStatus>
) => {
  state.profileUpdateStatus = action.payload;
};

const setProfileRequestStatus = (
  state: ProfileState,
  action: PayloadAction<RequestStatus>
) => {
  state.profileRequestStatus = action.payload;
};

const setProfileFilterRole = (
  state: ProfileState,
  action: PayloadAction<FilterRole>
) => {
  state.profileFilterRole = action.payload;
};

const reducers = {
  setTaxonomyOptionsByRole,
  setTaxonomyOptionsByRoleRequestStatus,
  setProfileUpdateStatus,
  setProfileRequestStatus,
  setProfileFilterRole,
};

export default reducers;
